export const questionStyles = {
  mainContainer: {
    display: "flex",
    flexDirection: "column",
    fontFamily: "Inter",
  },
  nodeInitial: {
    position: "relative",
    top: "20px",
    left: "10px",
    color: "#797b8c",
    textAlign: "center",
    paddingRight: "35px",
  },
  bottomRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    "&:hover": {
      cursor: "pointer",
    },
  },
  nodeBody: {
    margin: 0,
    padding: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    height: "30px",
    minWidth: "110px",
    fontSize: "16px",
    color: "#22304a",
    backgroundColor: "#ffad5c",
    borderRadius: "20px",
    marginBottom: "30px",
  },
  titleName: {
    marginLeft: "6px",
    margin: 0,
    padding: 0,
    fontSize: "12px",
    fontFamily: "Inter",
    fontWeight: 550,
  },
  nodeIcon: {
    fontSize: "16px",
    color: "#22304a",
    fontWeight: 600,
  },
  addIcon: {
    fontSize: "14px",
    height: "20px",
    width: "20px",
    color: "#22304a",
    borderRadius: "50%",
    backgroundColor: "white",
    marginLeft: "4px",
    transition: "visibility 0s, color 0.2s",
    position: "relative",
    bottom: "13px",
    "&:hover": {
      color: "blue",
    },
  },
  leftHandle: {
    background: "#566d89",
    opacity: "0",
    top: "-11px",
    position: "relative",
  },
  rightHandle: {
    background: "#566d89",
    opacity: "0",
    top: "3px",
    left: "24.5px",
    position: "relative",
  },
};
